<template lang="html">
	<vddl-draggable class="panel__body--item group"
					:draggable="item"
					:index="index"
					:disable-if="disable"
					:selected="selectedEvent"
					:wrapper="list"
					:type="type"
					:moved="handleMovedList"
					v-bind:class="{'selected': selectedItem === item, 'search-highlight': isHighlighted}">
		<div class="panel padding" v-if="item.type === 'CONTAINER'">
			<div class="panel__heading">
				<h3><span class="fa fa-ellipsis-v drag"></span> {{$t(item.title) || item.title}}</h3>
				<input type="hidden" class="text-edit" v-model="item.title">
				<span class="fa fa-pencil edit" @click="toggleInputEdit('group', $event)"></span>
        <span class="fa fa-plus add" title="Add group" @click="addGroup(item)"></span>
        <span class="fa fa-trash delete" title="Delete" @click="deletePanel(item)"></span>
			</div>
			<vddl-list class="panel__body"
					   :list="item.attributes"
					   :disable-if="disable"
					   :drop="handleDropList"
					   :allowed-types="['list', 'container', 'itemList']"
					   :external-sources="true">
				<list v-for="(col, index) in item.attributes"
					  :key="col.id"
					  :item="col"
					  :list="item.attributes"
					  :index="index"
					  :selected="selectedEvent"
					  :selected-item="selectedItem"
					  :disable-if="disable"
					  :disable="disable"
					  :localization="localization"
					  :item-structure="itemStructure"
					  :dropzones="dropzones"
					  :update-dropzones="updateDropzones"
					  @clear-input-container="clearInputContainer"
            @delete-panel="deletePanel(item)"
            @delete-element="deleteElement(item)"
            @copy-element="copyElement(item)"
					  :toggle-input-edit="toggleInputEdit"
					  :on-delete="onDelete"
					  :search-text="searchText"
				>
				</list>
			</vddl-list>
		</div>
		<p class="attribute" v-else>
			<span class="fa fa-ellipsis-v drag"></span>
			<template v-if="!itemStructure[item.title]">
				{{ item.title }}
			</template>
			<template v-else>
				{{( $t(itemStructure[item.title].title) || itemStructure[item.title].title) }}
			</template>
			<span class="fa" :class="locked ? 'fa-lock attribute_editable_lock': 'fa-unlock attribute_editable_unlock'" :title="locked ? $t('edit.locked'): $t('edit.unlocked')" @click="lockedAttributeEdit(item)"></span>
      <span class="fa fa-copy attribute_editable_copy" title="Copy attribute" @click="copyElement(item)"></span>
      <span class="fa fa-trash attribute_editable_trash" title="Delete" @click="deleteElement(item)"></span>
			<br/>
			<span>{{'{' + item.title + '}'}}</span>
		</p>
	</vddl-draggable>
</template>

<script>

import { showMessageAlert } from "@/core/shared";

export default {
	name: 'list',
	data () {
		return {
			type: 'list',
			locked: false
		}
	},
	props: [
		'item',
		'list',
		'index',
		'selected',
		'selectedItem',
		'disable',
		'currItem',
		'diff',
		'localization',
		'itemStructure',
		'dropzones',
		'updateDropzones',
		'toggleInputEdit',
		'onDelete',
		'searchText'
	],
	computed: {
		isHighlighted() {
			if (!this.searchText || this.searchText === '') return false
			const searchLower = this.searchText.toLowerCase()
			const title = this.item.title ? this.item.title.toLowerCase() : ''
			const localization = this.itemStructure[this.item.title] ?
				(this.$t(this.itemStructure[this.item.title].title) || this.itemStructure[this.item.title].title || '').toLowerCase() : ''
			return title.indexOf(searchLower) !== -1 || localization.indexOf(searchLower) !== -1
		}
	},
	methods: {
		selectedEvent (item) {
			if (typeof (this.selected) === 'function') {
				this.selected(item)
			}
		},
		handleDropList (data) {
			console.log(':v-list: drop 2')
			console.log(data)
			const { index, list, item } = data
			if (!this.disable) {
				item.id = Math.random()
				this.updateDropzones(this.dropzones, item)
				list.splice(index, 0, item)
				this.clearInputContainer()
			}
		},
		handleMovedList (item) {
			console.log(':v-draggable: moved 2')
			console.log(item)
			const { index, list } = item
			if (!this.disable) {

			}
		},
		clearInputContainer () {
			this.$emit('clear-input-container')
		},
		lockedAttributeEdit (item) {
			item.locked = !item.locked
			this.updateDropzones(this.dropzones, item)
			this.locked = item.locked
		},
    deletePanel (panel) {
      let obj = this.dropzones
      this.recursiveDelete(obj, panel)
      if (this.onDelete) {
        this.onDelete()
      }
    },
    deleteElement (item) {
      let obj = this.dropzones
      this.recursiveDelete(obj, item)
      if (this.onDelete) {
        this.onDelete()
      }
    },
    copyElement (item) {
      navigator.clipboard.writeText(item.title)
        .then(() => showMessageAlert('Attribute code copied!', 'success'))
        .catch(err => showMessageAlert('Attribute code not copied!', 'error'));
    },
    recursiveDelete (obj, item) {
      for (let i = 0; i < obj.length; i++) {
        if (typeof obj[i].attributes === 'object') {
          if (obj[i].title === item.title) {
            obj.splice(i, 1)
            i--
          } else {
            this.recursiveDelete(obj[i].attributes, item)
          }
        } else {
          if (obj[i].title === item.title) {
            obj.splice(i, 1)
            i--
          }
        }
      }
    },
    addGroup (zone) {
      this.recursiveAddedGroup(this.dropzones, zone)
    },
    recursiveAddedGroup (obj, zone) {
      for (let i = 0; i < obj.length; i++) {
        if (typeof obj[i].attributes === 'object') {
          if (obj[i].title === zone.title) {
            obj[i].attributes.splice(i, 0, {
              title: 'New group ' + Math.random().toString(36).substring(2, 9),
              attributes: [],
              type: "CONTAINER"
            })
            i++
          } else {
            this.recursiveAddedGroup(obj[i].attributes, zone);
          }
        }
      }
    }
	},
	created () {
		this.locked = this.item.locked ? this.item.locked : false
	}
}
</script>

<style lang="scss">
.attribute {
	position: relative;
	&:hover &_editable_unlock {
		display: block;
	}

  &:hover &_editable_copy {
    display: block;
  }

  &:hover &_editable_trash {
    display: block;
  }

	&:hover &_editable_unlock_label {
		display: block;
	}

	%editable_shared {
		position: absolute;
    top: 10px;
		padding: 5px;
		border-radius: 50%;
		background-color: #f5f5f5;
		&:hover {
			cursor: pointer;
		}
	}

	%editable_shared_label {
		position: absolute;
		top: 2px;
		right: 25px;
	}

	&_editable_unlock {
		display: none;
    right: 27px;
		@extend %editable_shared
	}

	&_editable_lock {
    right: 27px;
		@extend %editable_shared
	}

	&_editable_unlock_label {
		display: none;
		@extend %editable_shared_label
	}

	&_editable_lock_label {
		@extend %editable_shared_label
	}

  &_editable_copy {
    display: none;
    right: 53px;
    @extend %editable_shared;
  }

  &_editable_trash {
    display: none;
    right: 0;
    color: #ff00008a;
    @extend %editable_shared;
  }
}

.search-highlight {
  background-color: #fff3cd !important;
  border-left: 3px solid #ffc107;
}
</style>
